<script>
  import {isNumber, isInteger} from '@/EventLogic/util';
  import chosen from '../directives/chosen';

  export default {
    directives: {
      chosen
    },
    props: {
      config: Object
    },
    data: function() {
      return {
        errors: {}
      };
    },
    methods: {
      isNumber,
      isInteger,
      validate: function() {
        return true;
      },
      handleChange: function(event) {
        let val = event.target.value;

        if (event.target.tagName === 'SELECT' && event.target.multiple) {
          val = [].slice.call(event.target.selectedOptions).map(x => x.value);
        } else if (event.target.type === 'checkbox') {
          if (event.target.checked) {
            val = event.target.getAttribute('true-value') || true;
          } else {
            val = event.target.getAttribute('false-value') || false;
          }
        }

        this.$emit('update:' + event.target.name, val);
      }
    }
  };
</script>
